export const MODAL_SIZES = {
  XL: "xl",
  L: "l",
  M: "m",
  S: "s",
} as const

export type ModalSizeType = (typeof MODAL_SIZES)[keyof typeof MODAL_SIZES]
